export {
  DeckLinkedCardsTag,
  DeckLinkedCardsTagProps,
} from './DeckLinkedCardsTag';
